/* eslint-disable */
import React from 'react'
import styled from 'styled-components'

import { Grid, Row, Col } from 'react-flexbox-grid'
import { TitleOne, Paragraph } from '../../../components/text'
import BackgroundService from '../../../static/images/landing-page-one/background/background-service-test.svg'
import ServiceLeft from '../../../static/images/landing-page-one/background/service-left.svg'
import ServiceRight from '../../../static/images/landing-page-one/background/service-right.svg'
import time from '../../../static/images/about/animation/ic-time.webp'
import standar from '../../../static/images/about/animation/ic-standarisasi.webp'
import exp from '../../../static/images/about/animation/ic-experience.webp'
import { useTranslation } from "react-i18next";

const BackgroundImage = styled.img`
  position: absolute;
  z-index: -1;
  left: 0;
  right: 0;
  top: 170px;
  height: auto;
  width: 100%;
  display: block;
`

const ServiceCategoryStyles = styled.section`
  margin-top: 110px;
  @media screen and (min-width: 300px) and (max-width: 1023px) {
    margin-top: 40px;
    padding: 0 20px;
  }
  .service-background {
    &-right {
      position: absolute;
      right: 20px;
      height: 125px;
      width: 125px;
      bottom: -150px;
      z-index: -1;
      > img {
        display: block;
        width: 100%;
      }
    }
    &-left {
      position: absolute;
      left: 0px;
      height: 165px;
      width: 165px;
      top: 450px;
      > img {
        display: block;
        width: 100%;
      }
    }
  }

  @media screen and (min-width: 300px) and (max-width: 1023px) {
    .top-wrapper {
      width: 100% !important;
      margin: 20px 0 0 !important;
    }

    .service-background-left, .service-background-right, .background-image-1 {
      display: none;
    }

    .card-wrapper {
      margin-bottom: 20px;
    }
  }
`

const AboutCommitmentStyle = styled.div`
  height: 100%;
  .card {
    padding: 32px 0;
    border: 1px solid #ffe8d0;
    border-radius: 20px;
    background-color: #ffffff;
    box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    height: 100%;
    @media screen and (min-width: 300px) and (max-width: 1023px) {
      margin-bottom: 20px;
    }
    &-title {
      padding: 0px 20px;
      color: #ff7400;
      font-family: 'Open Sans';
      font-size: 24px;
      font-weight: 600;
      line-height: 33px;
      text-align: center;
      margin-bottom: 20px;
      text-align: center;
      width: 100%;
      display: block;
      min-height: 70px;
    }
    &-image {
      padding: 0;
      height: 165px;
      display: flex;
      width: 165px;
      background-color: #ffefde;
    }
    &-desc {
      color: #888888;
      font-family: 'Open Sans';
      font-size: 18px;
      line-height: 29px;
      padding: 0 32px;
      text-align: center;
    }
    img {
      display: block;
      width: 100%;
    }
  }
  .card-content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 100%;
  }
`

export const AboutCommitment = props => {
  const { image, title, desc } = props
  return (
    <AboutCommitmentStyle>
      <div className="card">
        <div className="card-image">
          <img src={image} alt="" />
        </div>
        <div className="card-content">
          <div className="card-title">{title}</div>
          <div className="card-desc">{desc}</div>
        </div>
      </div>
    </AboutCommitmentStyle>
  )
}

const Category = () => {
  const { t } = useTranslation();
  return (
    <ServiceCategoryStyles id="list-service" style={{ position: 'relative' }}>
      <TitleOne display="block" align="center">
        {t('pageAbout.part12')}
      </TitleOne>
      <div
        style={{
          textAlign: 'center',
          width: '50%',
          margin: '20px auto 0 auto',
          display: 'table'
        }}
        className="top-wrapper"
      >
        <Paragraph>
          {t('pageAbout.part13')}
        </Paragraph>
      </div>

      <div
        style={{
          position: 'relative',
          display: 'block',
          marginTop: '30px',
          height: window.innerWidth >= 300 && window.innerWidth <= 1023 ? 'unset' : 600
        }}
      >
        <BackgroundImage className="background-image-1" src={BackgroundService} alt=""></BackgroundImage>
        <div className="service-background-left">
          <img src={ServiceLeft} alt="" />
        </div>
        <div className="service-background-right">
          <img src={ServiceRight} alt="" />
        </div>
        <Grid>
          <Row>
            <Col xs={12} md={4} sm={12} lg={4} className="card-wrapper">
              <AboutCommitment
                image={standar}
                title={t('pageAbout.part14')}
                desc={t('pageAbout.part15')}
              ></AboutCommitment>
            </Col>
            <Col xs={12} md={4} sm={12} lg={4} className="card-wrapper">
              <AboutCommitment
                image={exp}
                title={t('pageAbout.part16')}
                desc={t('pageAbout.part17')}
              ></AboutCommitment>
            </Col>
            <Col xs={12} md={4} sm={12} lg={4} className="card-wrapper">
              <AboutCommitment
                image={time}
                title={t('pageAbout.part18')}
                desc={t('pageAbout.part19')}
              ></AboutCommitment>
            </Col>
          </Row>
        </Grid>
      </div>
    </ServiceCategoryStyles>
  )
}

export default Category
